// src/core/services/email.service.ts
import api from "@/core/services/axios";
import { withQuery } from "@/core/utils/queryParams";
import type { EmailMessage } from "@/models";

export class EmailService {
  constructor(private readonly baseRoute = "/mail") {}

  async sendMail(message: EmailMessage): Promise<void> {
    await api.post(`${this.baseRoute}/send`, message);
  }

  async logMail(message: EmailMessage, status: string): Promise<void> {
    const url = withQuery(`${this.baseRoute}/log`, { status });
    await api.post(url, message);
  }
}

export const emailService = new EmailService();
